export default "__VITE_ASSET__Ku4lPKrJ__"